import { ADD_NOTIFICATIONS, UPDATE_NOTIFICATION_ACTIONS } from '../actions/NotificationsActions';
import { NOTIFICATION_ACTIONS } from '../constants/NotificationConstants';
import { sortNotificationsByDate } from '../utils/notificationUtils';

const initialState = [];

const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_NOTIFICATIONS: {
      const { notifications } = action.payload;
      const sortedNotifications = sortNotificationsByDate(notifications);

      return [...sortedNotifications, ...state];
    }

    case UPDATE_NOTIFICATION_ACTIONS: {
      const { notificationsActions } = action.payload;

      //this action supports only one action type per time,
      // that means all items in notificationsActions will have same Action prop value
      const isOverallActionTypeDelete =
        notificationsActions[0].Action === NOTIFICATION_ACTIONS.DELETE;

      if (isOverallActionTypeDelete) {
        return state.filter((notification) => {
          const shouldBeDeleted = notificationsActions.find(
            (action) => action.NotificationId === notification.id
          );

          return !shouldBeDeleted;
        });
      }

      return state.map((notification) => {
        const newActionData = notificationsActions.find(
          (action) => action.NotificationId === notification.id
        );

        if (newActionData) {
          return { ...notification, action: newActionData.Action };
        }
        return notification;
      });
    }

    default:
      return state;
  }
};

export default notificationReducer;
